import styled from 'styled-components';

export default styled.div`
	display: flex;
	gap: var(--px-7);
`;
